
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93YFAxm_45JVOEdWr1_e_45esWCIlFpR6n0FeWZtOJ8YbiqyoMeta } from "/home/vsts/work/1/s/Src/frontend-app/src/pages/[...slug].vue?macro=true";
import { default as indexnOExh6iTDAQhz3aMN3NVUbDn34SrD1OJ5pSddiWv9zEMeta } from "/home/vsts/work/1/s/Src/frontend-app/src/pages/dashboard/index.vue?macro=true";
import { default as index8G2xmGca0vZC0GocpQ4cfPRC_45KFEp840JFhY_IFf1nUMeta } from "/home/vsts/work/1/s/Src/frontend-app/src/pages/dashboard/[patientId]/index.vue?macro=true";
import { default as _91orderId_93_vqB_45tH8IACD5DZDiV7BC6hPJ7h869sbdKVm9L85aTAMeta } from "/home/vsts/work/1/s/Src/frontend-app/src/pages/dashboard/[patientId]/[orderId].vue?macro=true";
import { default as component_45stubOKkTVKHVU4lbQ5ej6ZrdgknleeEqRAGZAqp2bMXIskgMeta } from "/home/vsts/work/1/s/Src/frontend-app/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@24.0.1_db0@0.3.2_eslint@9.28.0_jiti@2.4.2_b2c60a742ee4e675a9196ab51c4b3de1/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubOKkTVKHVU4lbQ5ej6ZrdgknleeEqRAGZAqp2bMXIskg } from "/home/vsts/work/1/s/Src/frontend-app/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@24.0.1_db0@0.3.2_eslint@9.28.0_jiti@2.4.2_b2c60a742ee4e675a9196ab51c4b3de1/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "slug___en",
    path: "/en/:slug(.*)*",
    meta: _91_46_46_46slug_93YFAxm_45JVOEdWr1_e_45esWCIlFpR6n0FeWZtOJ8YbiqyoMeta || {},
    component: () => import("/home/vsts/work/1/s/Src/frontend-app/src/pages/[...slug].vue")
  },
  {
    name: "slug___nl",
    path: "/nl/:slug(.*)*",
    meta: _91_46_46_46slug_93YFAxm_45JVOEdWr1_e_45esWCIlFpR6n0FeWZtOJ8YbiqyoMeta || {},
    component: () => import("/home/vsts/work/1/s/Src/frontend-app/src/pages/[...slug].vue")
  },
  {
    name: "slug___fr",
    path: "/fr/:slug(.*)*",
    meta: _91_46_46_46slug_93YFAxm_45JVOEdWr1_e_45esWCIlFpR6n0FeWZtOJ8YbiqyoMeta || {},
    component: () => import("/home/vsts/work/1/s/Src/frontend-app/src/pages/[...slug].vue")
  },
  {
    name: "slug___de",
    path: "/de/:slug(.*)*",
    meta: _91_46_46_46slug_93YFAxm_45JVOEdWr1_e_45esWCIlFpR6n0FeWZtOJ8YbiqyoMeta || {},
    component: () => import("/home/vsts/work/1/s/Src/frontend-app/src/pages/[...slug].vue")
  },
  {
    name: "dashboard___en",
    path: "/en/dashboard",
    component: () => import("/home/vsts/work/1/s/Src/frontend-app/src/pages/dashboard/index.vue")
  },
  {
    name: "dashboard___nl",
    path: "/nl/dashboard",
    component: () => import("/home/vsts/work/1/s/Src/frontend-app/src/pages/dashboard/index.vue")
  },
  {
    name: "dashboard___fr",
    path: "/fr/dashboard",
    component: () => import("/home/vsts/work/1/s/Src/frontend-app/src/pages/dashboard/index.vue")
  },
  {
    name: "dashboard___de",
    path: "/de/dashboard",
    component: () => import("/home/vsts/work/1/s/Src/frontend-app/src/pages/dashboard/index.vue")
  },
  {
    name: "dashboard-patientId___en",
    path: "/en/dashboard/:patientId()",
    component: () => import("/home/vsts/work/1/s/Src/frontend-app/src/pages/dashboard/[patientId]/index.vue")
  },
  {
    name: "dashboard-patientId___nl",
    path: "/nl/dashboard/:patientId()",
    component: () => import("/home/vsts/work/1/s/Src/frontend-app/src/pages/dashboard/[patientId]/index.vue")
  },
  {
    name: "dashboard-patientId___fr",
    path: "/fr/dashboard/:patientId()",
    component: () => import("/home/vsts/work/1/s/Src/frontend-app/src/pages/dashboard/[patientId]/index.vue")
  },
  {
    name: "dashboard-patientId___de",
    path: "/de/dashboard/:patientId()",
    component: () => import("/home/vsts/work/1/s/Src/frontend-app/src/pages/dashboard/[patientId]/index.vue")
  },
  {
    name: "dashboard-patientId-orderId___en",
    path: "/en/dashboard/:patientId()/:orderId()",
    component: () => import("/home/vsts/work/1/s/Src/frontend-app/src/pages/dashboard/[patientId]/[orderId].vue")
  },
  {
    name: "dashboard-patientId-orderId___nl",
    path: "/nl/dashboard/:patientId()/:orderId()",
    component: () => import("/home/vsts/work/1/s/Src/frontend-app/src/pages/dashboard/[patientId]/[orderId].vue")
  },
  {
    name: "dashboard-patientId-orderId___fr",
    path: "/fr/dashboard/:patientId()/:orderId()",
    component: () => import("/home/vsts/work/1/s/Src/frontend-app/src/pages/dashboard/[patientId]/[orderId].vue")
  },
  {
    name: "dashboard-patientId-orderId___de",
    path: "/de/dashboard/:patientId()/:orderId()",
    component: () => import("/home/vsts/work/1/s/Src/frontend-app/src/pages/dashboard/[patientId]/[orderId].vue")
  },
  {
    name: component_45stubOKkTVKHVU4lbQ5ej6ZrdgknleeEqRAGZAqp2bMXIskgMeta?.name,
    path: "/en/sitemap",
    component: component_45stubOKkTVKHVU4lbQ5ej6ZrdgknleeEqRAGZAqp2bMXIskg
  },
  {
    name: component_45stubOKkTVKHVU4lbQ5ej6ZrdgknleeEqRAGZAqp2bMXIskgMeta?.name,
    path: "/nl/sitemap",
    component: component_45stubOKkTVKHVU4lbQ5ej6ZrdgknleeEqRAGZAqp2bMXIskg
  },
  {
    name: component_45stubOKkTVKHVU4lbQ5ej6ZrdgknleeEqRAGZAqp2bMXIskgMeta?.name,
    path: "/fr/sitemap",
    component: component_45stubOKkTVKHVU4lbQ5ej6ZrdgknleeEqRAGZAqp2bMXIskg
  },
  {
    name: component_45stubOKkTVKHVU4lbQ5ej6ZrdgknleeEqRAGZAqp2bMXIskgMeta?.name,
    path: "/de/sitemap",
    component: component_45stubOKkTVKHVU4lbQ5ej6ZrdgknleeEqRAGZAqp2bMXIskg
  },
  {
    name: component_45stubOKkTVKHVU4lbQ5ej6ZrdgknleeEqRAGZAqp2bMXIskgMeta?.name,
    path: "/en/robots",
    component: component_45stubOKkTVKHVU4lbQ5ej6ZrdgknleeEqRAGZAqp2bMXIskg
  },
  {
    name: component_45stubOKkTVKHVU4lbQ5ej6ZrdgknleeEqRAGZAqp2bMXIskgMeta?.name,
    path: "/nl/robots",
    component: component_45stubOKkTVKHVU4lbQ5ej6ZrdgknleeEqRAGZAqp2bMXIskg
  },
  {
    name: component_45stubOKkTVKHVU4lbQ5ej6ZrdgknleeEqRAGZAqp2bMXIskgMeta?.name,
    path: "/fr/robots",
    component: component_45stubOKkTVKHVU4lbQ5ej6ZrdgknleeEqRAGZAqp2bMXIskg
  },
  {
    name: component_45stubOKkTVKHVU4lbQ5ej6ZrdgknleeEqRAGZAqp2bMXIskgMeta?.name,
    path: "/de/robots",
    component: component_45stubOKkTVKHVU4lbQ5ej6ZrdgknleeEqRAGZAqp2bMXIskg
  },
  {
    name: component_45stubOKkTVKHVU4lbQ5ej6ZrdgknleeEqRAGZAqp2bMXIskgMeta?.name,
    path: "/en/sitemap.xml",
    component: component_45stubOKkTVKHVU4lbQ5ej6ZrdgknleeEqRAGZAqp2bMXIskg
  },
  {
    name: component_45stubOKkTVKHVU4lbQ5ej6ZrdgknleeEqRAGZAqp2bMXIskgMeta?.name,
    path: "/nl/sitemap.xml",
    component: component_45stubOKkTVKHVU4lbQ5ej6ZrdgknleeEqRAGZAqp2bMXIskg
  },
  {
    name: component_45stubOKkTVKHVU4lbQ5ej6ZrdgknleeEqRAGZAqp2bMXIskgMeta?.name,
    path: "/fr/sitemap.xml",
    component: component_45stubOKkTVKHVU4lbQ5ej6ZrdgknleeEqRAGZAqp2bMXIskg
  },
  {
    name: component_45stubOKkTVKHVU4lbQ5ej6ZrdgknleeEqRAGZAqp2bMXIskgMeta?.name,
    path: "/de/sitemap.xml",
    component: component_45stubOKkTVKHVU4lbQ5ej6ZrdgknleeEqRAGZAqp2bMXIskg
  }
]